import React, { useMemo } from 'react';
import { message } from 'antd';
import { MessageContext } from './context';
import type { MessagesProviderProps } from './types';

export const MessagesProvider = ({ children }: MessagesProviderProps) => {
    /*
     * Хук возвращает [api, contextHolder]. contextHolder необходимо
     * отрендерить ровно один раз, иначе сообщение закроется при unmount‑е.
     */
    const [api, contextHolder] = message.useMessage();
    const value = useMemo(() => api, [api]);

    return (
        <MessageContext.Provider value={value}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    );
};
